// removed by extract-text-webpack-plugin
module.exports = {"buttons":"Button__buttons__8B44u","btn1":"Button__btn1__3-tGB","rect1":"Button__rect1__2MSMA","rect2":"Button__rect2__2Mkp4","Disabled":"Button__Disabled__2domB","ToolTip":"Button__ToolTip__kgFd-","text":"Button__text__3BtxB","firstRectIn":"Button__firstRectIn__2_cX_","secondRectIn":"Button__secondRectIn__3FC0J","firstRectOut":"Button__firstRectOut__3GvoN","secondRectOut":"Button__secondRectOut__1BR50"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/UI/Button/Button.css
// module id = 339
// module chunks = 0